// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".js?id=" + {"94":"dd1e76719aca46c2","720":"11aba12b86f7db0a","855":"73ff577a65a7af15"}[chunkId] + "";
};